export const NOTE_KEYS = {
  center: 'center',
  lateral: 'lateral',
  medial: 'medial',
  special: 'special',
  perfect: 'perfect',
  good: 'good',
  okay: 'okay',
  bad: 'bad',
  awful: 'awful',
  pre: 'pre',
  miss: 'miss',
  wrong: 'wrong',
};

export const RECEPTOR_VARIANTS = {
  reset: 'reset',
  wrong: 'wrong',
  combo: 'combo',
  special: 'special',
};

export const BAR_VARIANTS = {
  reset: 'reset',
  fadeIn: 'fadeIn',
  fadeOut: 'fadeOut',
};

export const FEEDBACK_VARIANTS = {
  reset: 'reset',
  show: 'show',
};
